import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseServices } from './kuba.services';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { shareReplay } from 'rxjs/operators';
@Injectable()
export class BusinessDepartmentService {
  _allDepartment: Observable<any> | any;

  constructor(private http: HttpClient) {}

  clearCachedAllDepartment() {
    this._allDepartment = null;
  }

  getCachedBusinessDepartment() {
    (this._allDepartment = this.http
      .get(
        environment.BASE_URL +
          '/departments/' +
          BaseServices.BusinessId +
          '/' +
          BaseServices.roleId
      )
      .pipe(map(response => response))),
      shareReplay(1);
    // refCount();

    return this._allDepartment;
  }

  /**
   * Creates a department for a business.
   *
   * Answers a duplicate name with an empty body rather than an error status,
   * which is the convention the other department endpoints in this app follow
   * — callers check for an Id before treating it as saved.
   */
  addDepartment(data: any) {
    this.clearCachedAllDepartment();
    return this.http
      .post(environment.BASE_URL + '/department', data)
      .pipe(map((response: any) => response));
  }

  getDepartmentsByBusinessId(businessId: number) {
    return this.http
      .get(environment.BASE_URL + '/getDepartmentsByBusinessId/' + businessId)
      .pipe(map(response => response));
  }

  getCachedBusinessDepartmentByBusinessId(businessId: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/departments/' +
          businessId +
          '/' +
          BaseServices.roleId
      )
      .pipe(map(response => response));
  }

  /**
   * Gets department dropdown for a business
   * @param businessId ID of the business
   * @param includeDefaults Determines whether to include default/shared departments. Default is false.
   * @returns List of departments for dropdown
   */
  getDepartmentDropdownForBusiness(
    businessId: number,
    includeDefaults: boolean = false
  ) {
    let httpParams = new HttpParams();
    if (includeDefaults) {
      httpParams = httpParams.set('includeSharedDepartments', true);
    }

    return this.http
      .get(
        environment.BASE_URL + '/businessdepartmentsdropdown/' + businessId,
        { params: httpParams }
      )
      .pipe(map((response: any) => response?.data || response));
  }
}
